<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="px-4">
    <v-col cols="12" xs="12">
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" class="pt-0">
        <v-row>
          <v-col cols="3" md="2" align-self="end">
            <v-btn @click="createComment" color="primary">
              <v-icon>add</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3" md="3" align-self="end">
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Suche"
                clearable
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>

      </v-col>

      <v-col cols="12" md="12">
        <v-data-table
        :headers="headers"
        :items="deviceList"
        :search="search"
        fixed-header
        :height="400"
        >
          <template v-slot:item.diskUsageCurrent="{ item }">
            <span :style="getHDStyle(item)">{{toMB(item.diskUsageCurrent, 2)}}</span><span> von {{toMB(item.diskUsageMax, 2)}}</span>
          </template>
          <template v-slot:item.company="{ item }">
            <span v-if="item.companyName" @click="openCompanyDialog(item)">{{item.companyName}}</span>
            <span v-if="!item.companyName" class="handpointer" :style="getCompanyStyle(item)"
                  @click="openCompanyDialog(item)">zuweisen</span>
          </template>

          <template v-slot:item.comment="{ item }">
            <span v-html="item.comment"></span>
          </template>
          <template v-slot:item.created="{ item }">
            {{formatDateTime(item.created)}}
          </template>
          <template v-slot:item.edited="{ item }">
            {{formatDateTime(item.edited)}}
          </template>
          <template v-slot:item.action="{ item }">
            {{actionNames[item.action]}}
          </template>
          <template v-slot:item.actionBtns="{ item }">
            <v-icon
                v-if="false"
            small
            class="mr-2"
            @click="editItem(item)"
            >
              edit
            </v-icon>
            <v-icon
            small
            @click="deleteItem(item)"
            >
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    </v-col>
    <DialogCreateComment ref="dlgCreateComment" @createItem="doCreateItem"></DialogCreateComment>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogCreateComment from "@/components/dialogs/DialogCreateComment";
import moment from "moment";

export default {
  name: 'TableComments',
  props: {
    companyId: String,
    deviceId: String
  },
  components: {DialogCreateComment},
  methods: {

    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    doCreateItem: function (item) {
      if (this.companyId) {
        item.guidCompany = this.companyId
      }
      if (this.deviceId) {
        item.guidDevice = this.deviceId
      }
      Vue.prototype.$api.createComment(item, this.reload)
    },
    createComment: function () {
      this.$refs.dlgCreateComment.open()
    },
    deleteItem: function (item) {
      Vue.prototype.$api.deleteComment(item.guid, this.reload)
    },
    editItem: function (item) {
      this.$router.push('/apps/' + item.guid)
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    formatDateTime: function (s) {
      return moment(s).format("DD.MM.YYYY HH:mm");
    },
    formatDateT: function (s) {
      return moment(s).format("DD.MM.YYYY");
    },
    reload: function () {
      var reqData = {

      }
      if (this.companyId) {
        reqData.guidCompany = this.companyId
      }
      if (this.deviceId) {
        reqData.guidDevice = this.deviceId
      }
      console.log('reload comments', reqData)
      Vue.prototype.$api.getCommentsWithFilter(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,

      headers: [
        {text: 'Aktion', align: 'left', value: 'action'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Erstellt', value: 'created'},
        {text: 'Verändert', value: 'edited'},
        {text: 'Aktion', value: 'actionBtns'}
      ],
      actionNames: {
        'manual': 'Default',
        'phone': 'Telefonat',
        'mail': 'E-mail',
        'contact': 'Kontakt',
      },
      deviceList: []
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  }
}
</script>

<style scoped>

</style>
